import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    akamaiList: [],
    akamai: null,
    links: null,
    meta: null,
    filter: {
      key: '',
      cache_key: '',
      do_action: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.akamaiList = [];
      state.akamai = null;
    },
    SET_AKAMAILIST(state, data) {
      state.akamaiList = data.data.map((item) => {
        item.isChecked = false;
        return item;
      });
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_AKAMAI(state, data) {
      state.akamai = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setAkamai({ commit }, data) {
      commit('SET_AKAMAI', data);
    },

    find({ commit, state }) {
      let url = `/akamai?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Akamai'));
          return response.body;
        })
        .then((response) => {
          commit('SET_AKAMAILIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/akamai/${id}`)
        .then((response) => response.body)
        .then(typeAs('akamai'))
        .then((item) => {
          commit('SET_AKAMAI', item);
        });
    },

    save(_, { id, ...data }) {
      const request = id
        ? http(`/akamai/${id}`, { method: 'PUT', data })
        : http('/akamai', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    clearAkamaiCache(_, { id, ...data }) {
      const request = id
        ? http(`/akamai/tag/${id}`, { method: 'PUT', data })
        : http('/akamai/tags', { method: 'POST', data });
      // const request = http(`/akamai/tags/${id}/`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    // 排序
    saveBulk({ commit }, payload) {
      console.log('資料已傳送至store:', payload.drangEndData);
      console.log('頁數:', payload.current_page);
      console.log('總共頁數', payload.last_page);
      console.log('單頁顯示筆數', payload.per_page);
      console.log('資料筆數從', payload.from, '到', payload.to);
      console.log('所有資料筆數', payload.total);
      console.log('所有資料筆數', payload);

      // payload.module = 'news';

      // 等api url
      const request = http(`/save_orders`, {
        method: 'PUT',
        data: payload,
      });
      return request.then((response) => response.body);
    },
  },
};
